<template>
    <div class="resol-tree">

        <div
            v-for="item in items"
            :key="item.id"
            class="div-table-rows-container"
        >

            <div 
                :class="[activeId === item.id  ? activeClass : '', item.isMain  ? 'font-weight-bold' : '', 'div-table-row']"
                @click.stop="actItemClick(item)"
                @dblclick.stop="actItemDblClick(item)"
            >

                <!-- Ячейка Текст-->
                <div class="div-table-row-cell" :style="{ 'width': `50%`, 'margin-left': `0px` }" >
                    
                    <div class="elipsis-text-wrap">

                        <!--Toggle-->
                        <span v-if="item.taskItems.length > 0">
                            <i :class="[ item.isOpen ? 'fas fa-caret-down' : 'fas fa-caret-right']" @click.stop="toggle(item)" @dblclick.stop="() => {}"></i>
                        </span>

                        <span v-if="!item.taskItems.length > 0" class="resol-tree-no-icon-area"></span>

                        <v-common-chip v-if="item.isCommon === true" document-type="IncomingDocument"/>
                        <div class="etw-text-container" v-tooltip.top-center="item.text">
                            <span class="etw-text">
                                {{ $t("Пункт") }} № {{ item.number }} {{ $t("от_время") }} {{ $moment(item.createDate).format("DD.MM.YYYY") }} &nbsp; - &nbsp; {{ item.text }}                                
                            </span>
                        </div>

                    </div>

                </div>

                <!-- Ячейка Исполнитель-->
                <div class="div-table-row-cell" style="width: 30%;">

                </div>

                <!-- Ячейка Контрольный срок-->
                <div class="div-table-row-cell" style="width: 10%;">
                    <span v-if="item.controlDate">
                        {{ $moment(item.controlDate).format('DD.MM.YYYY') }}
                    </span>
                </div>
                
                <!-- Ячейка Статус-->
                <div class="div-table-row-cell" style="width: 10%;">
                    <StatusChip :status="avaibleStatuses[$helpers.calculateDocumentStatus(item.controlStatus, item.controlDate, item.executionDate, item.hasResolution)]"/>
                </div>

                <!-- Ячейка для действий (для строки пунктов нужна как заглушка выравнивания)-->
                <div class="resol-tree-action-col">
                </div>

            </div>

            <TaskItem
                v-show="item.isOpen"
                v-for="task in item.taskItems"
                :key="task.id"
                :knownExecuters="knownExecuters"
                :item="task"
                :level="1"                
                :open-all="openAll"
                :active-id="activeId"
                :active-class="activeClass"
                :task-click="taskClickHandler"
                :task-dbl-click="taskDblClickHandler"
                :execution-click="executionClickHandler"
                :execution-dbl-click="executionDblClickHandler"
            />

        </div>

    </div>

</template>

<script>
import StatusChip from '@/components/StatusChip'
import TaskItem from '@/components/tabs/task-components/TaskItem.vue'

export default {
    name: "ActItemsTree",
    components: {
        TaskItem,
        StatusChip
    },
    data() {
        return {
            activeId : null,
            activeItem: null,
        }
    },
    props: {
        items: Array,
        activeClass: String,
        knownExecuters: Object,
        openAll: Boolean,
    },
    computed: {
        avaibleStatuses() {
            return this.$store.getters['references/GetAvaibleStatuses'];
        },
    },
    methods: {
        taskClickHandler(item) {
            if (this.activeId !== item.id) {
                this.activeId = item.id;
                this.activeItem = item;
                this.$emit('selected-change', item);
            }

            this.$emit('task-item-click', item);
        },
        taskDblClickHandler(item) {
            this.$emit('task-item-dbl-click', item);
        },
        executionClickHandler(item) {
            if (this.activeId !== item.executionId) {
                this.activeId = item.executionId;
                this.activeItem = item;
                this.$emit('selected-change', item);
            }
            
            this.$emit('execution-item-click', item);
        },
        executionDblClickHandler(item) {
            this.$emit('execution-item-dbl-click', item);
        },
        actItemClick(item) {
            if (this.activeId !== item.id) {
                this.activeId = item.id;
                this.activeItem = item;
                this.$emit('selected-change', item);
            }

            this.$emit('act-item-click', item);
        },
        actItemDblClick(item) {
            this.$emit('act-item-dbl-click', item);
        },
        toggle(item) {
            item.isOpen = !item.isOpen
        }
    },
    watch: {
        openAll(newValue) {
            this.items.forEach(x => x.isOpen = newValue);
        }
    }
}
</script>